import React from 'react'

const PujaListCard = ({ product, viewDetail, placeholderImg, isMobile }) => {
    return (
        <>

            <div
                className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 product-item-one"
                style={{
                    marginBottom: "15px",
                    width: "100%",
                    maxWidth: isMobile ? "50%" : "210px",
                }}
            >
                <div
                    className="card card-shadow-sty shadow-sm bg-white rounded p-2 w-100 d-flex h-100"
                    style={{ cursor: "pointer" }}
                    onClick={() => viewDetail(product)}
                >
                    <div className="product-image text-center position-relative">
                        <img
                            src={product.PUJA_IMAGE || placeholderImg}
                            alt={product.PUJA_NAME}
                            className="img-fluid rounded w-100"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = placeholderImg;
                            }}
                            style={{ objectFit: "contain", height: "180px" }}
                        />
                    </div>
                    <div className="product-details text-center d-flex align-item-center justify-content-center flex-column flex-grow-1 p-2 m-0">
                        <h6 style={{ fontSize: "18px", color: "#8f3246", fontWeight: "600" }}>
                            {product.PUJA_NAME}
                        </h6>
                        <div className="prod-details d-flex align-items-center flex-column">
                            <span style={{ fontSize: "16px", whiteSpace: "nowrap" }}>
                                ₹
                                {Math.round(product.PUJA_PRICE - product.DiscountAmount)}
                            </span>
                            <span
                                style={{
                                    whiteSpace: "nowrap",
                                    color: "#a52444",
                                    fontSize: "15px",
                                }}
                            >
                                View Details <i className="icon-right-arrow"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default PujaListCard
